import {useMemo, useState} from "react";
import {Dropdown, Form} from "react-bootstrap";
import {TopCategoryInterface} from "../../interfaces/catalog/TopCategoryInterface";
import {TopItem} from "../catalog/TopItem";

export default function TopCategories({categories}: { categories?: TopCategoryInterface[] }) {
    const [selectedBrands, setSelectedBrands] = useState<string[]>([]);

    const allBrands = useMemo(() => {
        const brands = new Set<string>();
        categories?.forEach(c => c.category.brands?.forEach(b => brands.add(b)));
        return Array.from(brands).filter(b => b !== 'Rotake').sort();
    }, [categories]);

    const toggleBrand = (brand: string) => {
        setSelectedBrands(prev =>
            prev.includes(brand) ? prev.filter(b => b !== brand) : [...prev, brand]
        );
    };

    const filteredCategories = useMemo(() => {
        if (selectedBrands.length === 0) return categories;
        return categories?.filter(c =>
            c.category.brands?.some(b => selectedBrands.includes(b))
        );
    }, [categories, selectedBrands]);

    const filtersQuery = selectedBrands.length > 0
        ? 'filters=' + encodeURIComponent('b:' + selectedBrands.join('|'))
        : undefined;

    return (
        <div className="about__category category">
            {allBrands.length > 0 && (
                <Dropdown className="about__brands-select d-sm-none mb-3" autoClose="outside">
                    <Dropdown.Toggle as="button" type="button" className="btn w-100 d-flex align-items-center justify-content-between">
                        <span className="text-truncate">
                            {selectedBrands.length > 0 ? 'Бренды: ' + selectedBrands.join(', ') : 'Все бренды'}
                        </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                        {allBrands.map(brand => (
                            <Dropdown.ItemText key={brand}>
                                <Form.Check
                                    id={'brand-' + brand}
                                    label={brand}
                                    checked={selectedBrands.includes(brand)}
                                    onChange={() => toggleBrand(brand)}
                                />
                            </Dropdown.ItemText>
                        ))}
                        {selectedBrands.length > 0 && <>
                            <Dropdown.Divider/>
                            <Dropdown.Item as="button" type="button" onClick={() => setSelectedBrands([])}>Сбросить</Dropdown.Item>
                        </>}
                    </Dropdown.Menu>
                </Dropdown>
            )}
            {allBrands.length > 0 && (
                <div className="d-none d-sm-flex flex-wrap gap-2 mb-3 justify-content-center">
                    {allBrands.map(brand => (
                        <button
                            key={brand}
                            type="button"
                            className={`btn btn-sm`}
                            style={selectedBrands.includes(brand)
                                ? {backgroundColor: 'var(--bs-secondary)', borderColor: 'var(--bs-secondary)', color: '#fff'}
                                : {backgroundColor: 'var(--bs-orange)', borderColor: 'var(--bs-orange)', color: '#fff'}}
                            onClick={() => toggleBrand(brand)}
                        >
                            {brand}
                        </button>
                    ))}
                </div>
            )}
            <div className="mb-4 category mb-lg-5">
                <div className="gx-3 gx-md-6 row gy-7">
                    {filteredCategories?.map((category, index) => (
                        <TopItem key={index} category={category.category} filtersQuery={filtersQuery}/>
                    ))}
                </div>
            </div>
        </div>
    );
}
